import failWithAnimation from './fail_animated.svg'
import failNoAnimation from './fail_no_animation.svg'
import errorWithAnimation from './error_animated.svg'
import errorNoAnimation from './error_no_animation.svg'
import inspectionWithAnimation from './inspection_animated.svg'
import inspectionNoAnimation from './inspection_no_animation.svg'
import successWithAnimation from './success_animated.svg'
import successNoAnimation from './success_no_animation.svg'
import isInternetExplorer from '../../util/internetExplorerHelper'

export const Sources = Object.freeze({
  FAIL: { withAnimation: failWithAnimation, noAnimation: failNoAnimation },
  ERROR: { withAnimation: errorWithAnimation, noAnimation: errorNoAnimation },
  INSPECTION: {
    withAnimation: inspectionWithAnimation,
    noAnimation: inspectionNoAnimation,
  },
  SUCCESS: {
    withAnimation: successWithAnimation,
    noAnimation: successNoAnimation,
  },
})

export const getSourceIfInternetExplorer = source => {
  return isInternetExplorer() ? source.noAnimation : source.withAnimation
}

export const rejectedAnimation = getSourceIfInternetExplorer(Sources.FAIL)
export const inspectionAnimation = getSourceIfInternetExplorer(
  Sources.INSPECTION,
)
export const errorAnimation = getSourceIfInternetExplorer(Sources.ERROR)
export const successAnimation = getSourceIfInternetExplorer(Sources.SUCCESS)
